"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jtString = exports.ProfessionalPlanName = exports.ProPlanName = exports.PlusPlanName = exports.CorePlanName = exports.ChecklistEditorName = exports.MarkdownEditorName = exports.RichTextEditorName = exports.CodeEditorName = exports.SpreadsheetName = exports.AuthenticatorName = exports.BoldName = exports.FileSafeName = exports.ClipperName = exports.SuperName = exports.ListedName = exports.AppName = void 0;
exports.AppName = 'Standard Notes';
exports.ListedName = 'Listed';
exports.SuperName = 'Super';
exports.ClipperName = 'Web Clipper';
exports.FileSafeName = 'FileSafe';
exports.BoldName = 'Bold';
exports.AuthenticatorName = 'Authenticator';
exports.SpreadsheetName = 'Spreadsheet';
exports.CodeEditorName = 'Code';
exports.RichTextEditorName = 'Rich Text';
exports.MarkdownEditorName = 'Markdown';
exports.ChecklistEditorName = 'Checklist';
exports.CorePlanName = 'Core';
exports.PlusPlanName = 'Plus';
exports.ProPlanName = 'Pro';
exports.ProfessionalPlanName = 'Professional';
function jtString(value) {
    return Array.isArray(value) ? value.join('') : String(value);
}
exports.jtString = jtString;
